import { render, staticRenderFns } from "./impostosNfeSimples.vue?vue&type=template&id=28973e0a&scoped=true&"
import script from "./impostosNfeSimples.vue?vue&type=script&lang=js&"
export * from "./impostosNfeSimples.vue?vue&type=script&lang=js&"
import style0 from "./impostosNfeSimples.vue?vue&type=style&index=0&id=28973e0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28973e0a",
  null
  
)

export default component.exports